import React, {Component} from 'react';
import axios from 'axios';
import {ToastContainer, ToastStore} from 'react-toasts';
import LostItemFunctions from './LostItemFunctions';
import {SERVER_URL, LOCAL_URL, PAPER_SIZE_LETTER, PAPER_SIZE_LABEL, PAPER_SIZE_LABEL_2BY4}  from '../Constants';

var QRCode = require('qrcode.react');

class BatchPrintInventory extends Component {
  constructor(props) {
    super(props);
    console.log('props=' + props);
    this.state = {
        venueid:-1,
        lostItem: null,
        id:-1,
        shortDescription: '',
        longDescription: '',
        disabled :false,
        publishPicture :false,
        center: {
          lat: 40,
          lng: -70,
        },
        zoom: 14,
        itemState:'Q',
        publishedDate: Date.now,
        keywords:'',
        claimCallengerDetails:'',
        foundDate: Date.now,
        showSuccess: false,
        locationName:'',
        showNewClaim: false,
        showOpenClaim: false,
        selectedClaimId: '',
        refreshLostItemClaims:false,
        claims:[],
        foundByName:'NA',
        paperSize:PAPER_SIZE_LETTER,
        isPrinting:false
    };
  }

  async componentDidMount() {
    
    
    
    console.log('print id=' + this.props);
    var paperSize = '';
    var token = '';
    let ids = '';
    let venueId = '';
    if (this.props.match.params.params){
        var params = this.props.match.params.params.split('&');
        console.log('params=' + params);
        // first param is the layout
        // the second is th eids
        // the third is the token

        paperSize= params[0].split('=')[1];
        ids= params[1].split('=')[1];
        token= params[2].split('=')[1];
        venueId = params[3].split('=')[1];
    }else{
      return (
        <div> Invalid ID </div>
      );
    }
  
    const results = (await axios.post(`${SERVER_URL}/LostItems/getitems/`,
     {
        'ids': ids
        },
        {
      headers: { 
        'Authorization': `Bearer ${token}`,
        'venueId': venueId,
        'Content-Type': 'application/json'
      }}
  
     )).data; 
     console.log(results);
    this.setState({
        lostItems : results,
        paperSize:paperSize,
        venueId:venueId
        /*id: lostItem.id,
        itemState:lostItem.itemState,
        shortDescription: lostItem.shortDescription,
        longDescription: lostItem.longDescription, 
        locationName:lostItem.locationName,
        foundByName:lostItem.foundByName,
       
        url: lostItem.url, 
        center:  {
          lat: lostItem.latitude,
          lng: lostItem.longitude
        },
        published : lostItem.published,
        publishedDate: lostItem.publishedDate,
        publishPicture:lostItem.publishPicture,
        keywords:lostItem.keywords,
        claimCallengerDetails: lostItem.claimCallengerDetails,
        foundDate: (lostItem.foundDate) ? new Date(lostItem.foundDate) : new Date(),
        itemNumber:lostItem.itemNumber,
        finderClaimed:lostItem.finderClaimed,
`       */
    });
   
  


  }
  handleDismiss=()=> {
    this.setState({ showAlert: false });
  }
  renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}

  changeSize=(size)=>{

    this.setState({
      paperSize:size,
      isPrinting:false
    })
  
  }
  renderStyle =()=>{
    /* console.log("Render style")
    if (this.state.paperSize===PAPER_SIZE_LETTER){
      return(
        <style type="text/css">
            {"@media print{@page {size: portrait}}"}
        </style>
      )
    }else if (this.state.paperSize===this.state.PAPER_SIZE_LABEL_2BY3){
      
      return(
        <style type="text/css">
            {"@media print{@page {size: landscape}}"}
        </style>
      )
    }*/
    /*let orientationStr = 'landscape';
    const child = document.getElementById('page-orientation');
    console.log('child:' + child);
    if (child && child.parentnode) {child.parentnode.removeChild(child);}
    const style = document.createElement('style');
    style.innerhtml = `@page {size: ${orientationStr}}`;
    style.id = 'page-orientation';
    document.head.appendChild(style);
    */

  };
  landscapeOrientation = () => (
   //size:letter landscape !important
    <style type="text/css">
      {"@media print{@page { margin: 5mm !important; size: letter landscape; } html, body, .container {width: 100% !important; min-width: auto !important; margin-top: 9mm; margin-bottom: 1mm; margin-left: 0mm; margin-right: 0mm} header, footer, nav, aside, form, video, audio .adslot {display: none;}}"}
    </style>

  );

  print=()=>{
    this.setState({
    
      isPrinting:true
    },()=>{
      window.print();
    })
   

    /*const content = document.getElementById('divcontents');
      let win = window.open();
      win.document.write('<html><head><title>Print it!</title><link rel="stylesheet" type="text/css" href=""https://bootswatch.com/4/lux/bootstrap.min.css"> <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js" integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl" crossorigin="anonymous"></script></head><body>');
      win.document.write(content.innerHTML);
      win.document.write('</body></html>');
      win.document.close();
      //w.document.write(content.innerHTML);
  */
    }

    renderFourBySix=(item)=>{

      const style = {    
       
       label:{margin: '10px'},

        title:{
         fontSize: '38px',
         color:'black'
       },
       description:{
        fontSize: '38px',
        color:'black'
      },
      longDescription:{
        fontSize: '38px',
        color:'black'
      },
       details:{
        fontSize: '42px',
        color:'black'
      },
      detailsDate:{
        fontSize: '32px',
        color:'black'
      },
      keywords:{
        fontSize: '28px',
        color:'black'
      }
      ,
      datePrinted:{
        fontSize: '18px',
        color:'black'
      }
      }

      return (
        <div style={style.label} ref={el => (this.componentRef = el)}>
         
     
         <div  className='row'>
           
               
           <div className='col-8'> 
               <h1 style={style.description}>{item.shortDescription}</h1>
           </div>
           <div className='col-4 text-right'>
                <h2 style={style.title}>Item: {item.itemNumber}</h2>
            
                </div>

          
          </div>    

          <hr/>
               
           
           <div class="row">
                <div className='col-6'> <p style={style.details} className="lead"><b>Date Found:</b></p> </div>
              
  
                <div className='col-6'> <p style={style.detailsDate} >{(item.foundDate) ? LostItemFunctions.formatDateLongDate(new Date(item.foundDate)): ''}</p></div>
           </div>
           <div class="row">
                <div className='col-6'> <p style={style.details} className="lead"><b>Found By:</b></p> </div>
                <div className='col-6'> <p style={style.detailsDate} >{item.foundByName}</p></div>
           </div>
           <div class="row">
                <div className='col-6'> <p style={style.details} className="lead"><b>Found Location:</b></p> </div>
                <div className='col-6'> <p style={style.detailsDate} >{item.locationName}</p></div>
           </div>
           <div class="row">
                <div className='col-6'> <p style={style.details} className="lead"><b>Status:</b></p> </div>
                <div className='col-6'> <p style={style.detailsDate} >{LostItemFunctions.itemStatusDesc(item.itemState)}</p></div>
           </div>
            
           <div class="row">
                <div className='col-6'> <p style={style.details} className="lead"><b>Description:</b></p> </div>
                <div className='col-6'> <p style={style.detailsDate} >{item.longDescription}</p></div>
           </div>
           <div class="row">
                <div className='col-6'> <p style={style.details} className="lead"><b>Will Claim:</b></p> </div>
                <div className='col-6'> <p style={style.detailsDate} >{(item.finderClaimed) ? 'YES' : 'NO'}</p></div>
           </div>


            <div class="row">
                <div className='col'>
                    <p style={style.details} > <b>Keywords:</b> </p>
                </div>
            </div>
            <div class="row">
             
              <div className='col'> 
                <p style={style.keywords}  className="display-5">{item.keywords}</p> 
              </div>
            </div>
          <br/>
         
          <hr/>
          <div className='row'>
                <div className='col'>
                        <QRCode style={{width: 300, height:300}} value={`${LOCAL_URL}/Lostitem/` + item.id} />
            
                </div>
                <div className='col text-right'>  <img style={{width: 300, height:300}} src={item.url} alt={item.shortDescription}/>  </div>
            </div>
            <br/>

          <br/>
          <div class="row">
          <div className='col'> <h6 style={style.datePrinted}><b>Printed:</b> {LostItemFunctions.formatDate(new Date()) + ' at ' + LostItemFunctions.formatTime(new Date()) }</h6> </div>
             
          </div>
         

          {
          //this.renderStyle()
          }
      </div>
      )
    }

    truncateString=(txtDescr, len)=>{
      if (txtDescr){
        if (txtDescr.length >=len){
          return txtDescr.substring(0,len) + '..';
        }else{
          return txtDescr;
        }
      }
    }
    // Small Label
    renderTwoByFour=(item)=>{

      const style = {
        
       label:{
          marginTop: '2mm',
          marginLeft: '0mm',
          //width:'4.5in',
          //height:'2.313in',
          backgroundColor:'white'
        },

        itemNumber:{
         fontSize: '4.7rem',
         color:'black',
         fontWeight:'bold'
       },
       description:{
        fontSize: '3.9rem',
        color:'black',
        fontWeight:'bold'
      },
      longDescription:{
        fontSize: '2.5rem',
        color:'black'
      },
       details:{
        fontSize: '2.5rem',
        color:'black'
      },
      detailsDate:{
        fontSize: '2.4rem',
        color:'black',
        fontWeight:'bold'
      },
      detailsText:{
        fontSize: '2.4rem',
        color:'black',
        fontWeight:'bold'
      },
      parcelText:{
        fontSize: '1.5rem',
        color:'black',
        
      },
      keywords:{
        fontSize: '2.5rem',
        color:'black'
      }
      ,
      datePrinted:{
        fontSize: '1.5rem',
        color:'black'
      },
      checkInitialTitle:{
        fontSize: '1.6rem',
        color:'black',
        
      }
    }

      return (
        <div style={style.label} ref={el => (this.componentRef = el)}>
         
     
         <div  className='row'>
       
          <div className='col-12 text-left'> 
                <div class="row">
                    <div className='col text-left'>
                        <p style={style.description}>{this.truncateString(item.shortDescription, 30)}</p>
                    </div>
                   
                </div>
             
                  <div class="row">
                      <div className='col-3'> <p style={style.details} className="lead"><b>Date Found:</b></p> </div>
                      <div className='col'> <p style={style.detailsDate} >{(item.foundDate) ? LostItemFunctions.formatDateLongDate(new Date(item.foundDate)): ''}</p></div>
                </div>
                <div class="row">
                      <div className='col-3'> <p style={style.details} className="lead"><b>Found By:</b></p> </div>
                      <div className='col'> <p style={style.detailsText} >{item.foundByName}</p></div>
                </div>
                <div class="row">
                      <div className='col-3'> <p style={style.details} className="lead"><b>Found Loc.:</b></p> </div>
                      <div className='col'> <p style={style.detailsText} >{item.locationName}</p></div>
                </div>
                <div class="row">
                    <div className='col-3'> <p style={style.details} className="lead"><b>Description:</b></p> </div>
                    <div className='col'> <p style={style.detailsText} >{this.truncateString(item.longDescription, 50)}</p></div>
                </div>
                <div class='row' style={{backgroundColor:'transparent'}} >
                    <div className='col-2'> <p style={style.parcelText} className="lead"><b>Parcel Pass:</b></p> </div>
                    <div className='col-1'> <input class="form-check-input" style={{width:'50px', height:'50px'}} type="checkbox" value="" id="flexCheckChecked" checked=""/> </div>
                    <div className='col-2'> <p style={style.parcelText} className="lead"><b>Date:</b></p> </div>
                    <div className='col-2'> <p style={style.parcelText} className="lead"><b>____/___/____</b></p></div>
                    <div className='col-2'> <p style={style.parcelText} className="lead"><b>Initial:</b></p> </div>
                    <div className='col-2'> <p style={style.parcelText} className="lead"><b>______</b></p></div>
                </div>
              
              
           </div>
          

          
          </div>   
         
        
          <div class="row">
            <div className='col-6 text-left' style={{ justifyContent:'left', alignItems:'top', backgroundColor:'transparent'}}>
   
                   
                   

                <h2 style={style.itemNumber}>Item: {item.itemNumber}</h2>
            </div>
            <div className='col-5 text-right'> 
                  <QRCode style={{width: 200, height:200, padding:'2px'}} value={`${LOCAL_URL}/Lostitem/` + item.id} />
                  <br/>
                  <small style={style.datePrinted}><b>Printed:</b> {LostItemFunctions.formatDate(new Date()) + ' at ' + LostItemFunctions.formatTime(new Date()) }</small> 
            </div>
           
             
          </div>
        

      </div>
      )
    }
    /*
      NAME:  renderPortrait

    */
    renderDefault=(item)=>{
      return (
        <div key={item.id} ref={el => (this.componentRef = el)}>
         
     
         <div  className='row'>
           
               
           <div className='col'> 
               <h1 >{this.state.shortDescription}</h1>
           </div>
           <div className='col text-right'>
                <h2 className="display-5">Item: {item.itemNumber}</h2>
            
                </div>

          
          </div>    

           
               
           
           <div class="row">
                <div className='col'> <p className="lead"><b>Date Found:</b> {(item.foundDate) ? LostItemFunctions.formatDateLongDate(new Date(item.foundDate)): ''}</p> </div>
                <div className='col'> <p className="lead"><b> Found By:</b> {item.foundByName}</p> </div>
                <div className='col'> <p className="lead"><b> Found Location:</b>  {item.locationName}</p> </div>
                <div className='col'> <p className="lead"><b>Will Claim:</b> {(item.finderClaimed) ? 'YES' : 'NO'}</p> </div>
                <div className='col text-right' > <p className="lead"><b>Status: </b> {LostItemFunctions.itemStatusDesc(item.itemState)}</p> </div>
                
            </div>
            <div class="row">
              
                <div className='col'> <b>Description:</b><h5 className="display-5">{item.longDescription}</h5> </div>
            </div>
            <div class="row">
              
              <div className='col'> <h6 className="display-5">{item.keywords}</h6> </div>
          </div>
          <br/>
          <br/><br/>
          
          <div className='row'>
                <div className='col'>
                        <QRCode value={`${LOCAL_URL}/Lostitem/` + item.id} />
            
                </div>
                <div className='col text-right'>  <img style={{width: 135, height:135}} src={item.url} alt={item.shortDescription}/>  </div>
            </div>
            <br/>

          <br/><br/><br/>
          <div class="row">
          <div className='col'> <h6><b>Printed:</b> {LostItemFunctions.formatDate(new Date()) + ' at ' + LostItemFunctions.formatTime(new Date()) }</h6> </div>
             
          </div>
         

         
      </div>
      )
    }
renderBatchLetter=()=>{
    console.log('renderBatchLetter' + this.state.lostItems);
    if (this.state.lostItems){
        return this.state.lostItems.map((item, index)=>{
            return(
                <div  key={index}  style={{ breakAfter: (index<this.state.lostItems.length-1) ? "page": "avoid" }}>
                {this.renderDefault(item)}
            </div>
            )
        })
        }
}
renderBatchFourBySix=()=>{
    console.log('renderBatchLetter' + this.state.lostItems);
    if (this.state.lostItems){
        return this.state.lostItems.map((item, index)=>{
            return(
                <div  key={index}  style={{ breakAfter: (index<this.state.lostItems.length-1) ? "page": "avoid" }}>
                {this.renderFourBySix(item)}
            </div>
            )
        })
        }
}
renderBatchTwoByFour=()=>{
   
    if (this.state.lostItems){
        return this.state.lostItems.map((item, index)=>{
            return(
            <div  key={index}  style={{ breakAfter: (index<this.state.lostItems.length-1) ? "page": "avoid" }}>
                {this.renderTwoByFour(item)}
            </div>
            )
        })
        }
}

renderInventoryLabel=()=>{
  console.log("Current size:" + this.state.paperSize)
  switch (this.state.paperSize){
        case PAPER_SIZE_LETTER: return this.renderBatchLetter(); 
        case PAPER_SIZE_LABEL: return this.renderBatchFourBySix(); 
        case PAPER_SIZE_LABEL_2BY4: return this.renderBatchTwoByFour(); 
        default: return null;
  }
    


}

  render() {

   
  
    
    

    return (
      <div>
          {!(this.state.isPrinting) && 
            <div className='row'>
                <div className='col text-end'>
                 
                  <button className='btn btn-success btn-sm' onClick={()=>{this.print()}}>Print</button>
                </div>
            </div>
         }
     
        
       {this.renderInventoryLabel()}
       {
         (this.state.paperSize===PAPER_SIZE_LABEL_2BY4)? this.landscapeOrientation(): null
          }


       </div>

    )
   
  

   


    
  }
}

export default BatchPrintInventory;